import { BASE_URL, LANGUAGE } from "constants/api";
import axios from "../helpers/axiosInstance";
import { HeadCell } from "models/app";
import { ILanguage, ILanguageInput } from "models/language";

export async function getLanguages(params: string = "") : Promise<ILanguage[]> {
  const response = await axios.get(BASE_URL + LANGUAGE + params);
  return response.data;
}
export async function addLanguage(data: ILanguageInput) {
  const response = await axios.post(BASE_URL + LANGUAGE, data);
  return response.data;
}
export async function editLanguage(data: ILanguageInput, id: string) {
  
  const response = await axios.patch(BASE_URL + LANGUAGE + "/" + id, data);
  return response.data;
}

export async function deleteLanguage(id: string) {
  const response = await axios.delete(BASE_URL + LANGUAGE + "/" + id);
  return response.data;
}

export const LanguageCells: HeadCell[] = [
  {
    id: "name",
    numeric: false,
    disablePadding: false,
    label: "T_name",
  },
  {
    id: "nameAr",
    numeric: false,
    disablePadding: false,
    label: "T_name_Ar",
  },
  
  {
    id: "actions",
    numeric: false,
    disablePadding: false,
    label: "T_action",
  },
];
